import React from 'react'
import { ApplicationSubmittedProps, CreditApplicationErrors } from './types'
import { useApp } from '../../AppContext/AppProvider'
import { ApplicationWaitingComponent } from './ApplicationWaiting.component'
import {
  postBranchLogEvent,
  BRANCH_LOG_EVENTS
} from '../../../services/branch.service'
import { useIntervalPromise } from '../../../hooks/Poller.hook'
import {
  getApplicationStatus,
  isErrorStatus,
  mapCreditApplicationError
} from '../../../services/creditApplication.service'
import { extractMessageFromServiceError } from '../../../services/error.service'
import { CreditApplicationStatus } from '../../../domain/creditApplication'

export const ApplicationSubmittedContainer: React.FC<
  ApplicationSubmittedProps
> = ({ applicationId, handleReady, handleError }) => {
  const { application } = useApp()
  const getCcAppStatus = getApplicationStatus(application)

  useIntervalPromise(async () => {
    try {
      const creditApplication = await getCcAppStatus(applicationId)
      if (creditApplication.status === CreditApplicationStatus.ready) {
        postBranchLogEvent(BRANCH_LOG_EVENTS.APP_PREAPPROVED)
        handleReady(creditApplication)
      } else if (isErrorStatus(creditApplication.status)) {
        handleError(mapCreditApplicationError(creditApplication.status))
      }
    } catch (err) {
      handleError({
        type: CreditApplicationErrors.HTTP,
        errorMessage: extractMessageFromServiceError(err)
      })
    }
  }, 2000)

  return <ApplicationWaitingComponent />
}
